import { useQuery } from "@tanstack/react-query";
import { getInvitations } from "@/api/endpoints";
import { Badge, Card, PageTitle } from "@/components/ui/primitives";
import { DataState } from "@/components/data-state";

/**
 * Open invitations across every tenant — the page to look at when someone
 * reports that an invitation never arrived.
 */
export function InvitationsPage() {
  const query = useQuery({ queryKey: ["system-invitations"], queryFn: getInvitations });

  return (
    <div className="space-y-4">
      <PageTitle>Bekleyen davetler</PageTitle>
      <DataState
        isLoading={query.isLoading}
        isError={query.isError}
        isEmpty={(query.data?.length ?? 0) === 0}
        onRetry={() => void query.refetch()}
      >
        <Card className="divide-y divide-border">
          {query.data?.map((invitation) => {
            const expired = new Date(invitation.expiresAt) < new Date();
            return (
              <div key={invitation._id} className="flex items-center gap-3 p-3">
                <div className="min-w-0 flex-1">
                  <p className="truncate font-medium">{invitation.email}</p>
                  <p className="text-xs text-muted-foreground">
                    {new Date(invitation.createdAt).toLocaleDateString()} · {invitation.orgId}
                  </p>
                </div>
                <Badge>{invitation.role}</Badge>
                <Badge tone={expired ? "danger" : "neutral"}>
                  {expired
                    ? "Süresi doldu"
                    : new Date(invitation.expiresAt).toLocaleDateString()}
                </Badge>
              </div>
            );
          })}
        </Card>
      </DataState>
    </div>
  );
}
